<template>
  <v-container>
      <h1><b> Iklan</b></h1>
      <br />
      <PantauIB
        :idIklan="idIklan"
        v-if="hits.id_mst_iklan_jenis == 1"
      />
      <PantauTB
        :idIklan="idIklan"
        v-if="hits.id_mst_iklan_jenis == 2"
      />
      <PantauAS
        :idIklan="idIklan"
        v-if="hits.id_mst_iklan_jenis == 5"
      />
  </v-container>
</template>

<script>
import PantauIB from '@/components/PantauIB.vue';
import PantauTB from '@/components/PantauTB.vue';
import PantauAS from '@/components/PantauAS.vue';
export default {
    name: 'iklan',
    components: {
        PantauIB,PantauTB,PantauAS
    },
    data: () => ({
        hits: [],
        idIklan:'',
    }),
    methods: {
        async getDtlIklan() {
            await this.$req
                .get(this.$root.$baseapi.search+'/search/v4/search', {
                    params: {
                        id: this.$route.query.id,
                        // search: this.$route.params.id,
                        limit: 1,
                    },
                })
                .then((response) => {
                    let data = response.data
                    let { hits } = data.hits
                    this.hits = hits[0]._source
                    console.log('ini iklannya', this.hits)
                    })
                .catch((error) => {
                    let responses = error.response.data
                    console.log(responses.api_message)
                })
            },
    },
    async created() {
        this.getDtlIklan()
        this.idIklan = this.$route.query.id
    },
}
</script>

<style>

</style>